/**
 * Shape store to map rendering subscription.
 * Watches shapesStore changes and updates the map accordingly.
 */

import { useEffect } from 'react';
import type { MapInstance, ViewMode } from '@/map/map-setup';
import { updateShapes } from '@/map/shapes';
import { useShapesStore } from '@/stores/shapes-store';

/** Subscribe shapes store changes to map rendering */
export function useShapeSubscriptions(
  mapRef: React.RefObject<MapInstance | null>,
  modeRef: React.RefObject<ViewMode>,
): void {
  useEffect(() => {
    let prevShapes = useShapesStore.getState().shapes;
    let prevAreas = useShapesStore.getState().areaShapes;

    const unsub = useShapesStore.subscribe((state) => {
      const changed = state.shapes !== prevShapes || state.areaShapes !== prevAreas;
      if (changed && mapRef.current) {
        prevShapes = state.shapes;
        prevAreas = state.areaShapes;
        updateShapes(mapRef.current, modeRef.current, [...state.shapes, ...state.areaShapes]);
      }
    });

    return unsub;
  }, []);
}
